import * as Lookup from "./lookup";
export const halveTongbewegingen = [
    { key: "materiaal", question: "Q_MATERIAL", options: Lookup.materiaal.map((x, i) => ({ value: x, index: i })) },
    { key: "been", question: "Q_LEFT_RIGHT", options: Lookup.been.map((x, i) => ({ value: x, index: i })) },
    { key: "smeerlozeConstructie", question: "Q_LUBRICANT_FREE_CONSTRUCTION", options: Lookup.smeerlozeConstructie.map((x, i) => ({ value: x, index: i })) },
    { key: "wisselVerwarmingVoorbereid", question: "Q_SWITCH_HEATING", options: Lookup.wisselVerwarmingVoorbereid.map((x, i) => ({ value: x, index: i })) },
    { key: "bediening", question: "Q_SWITCH_OPERATION", options: Lookup.bediening.map((x, i) => ({ value: x, index: i })) },
    { key: "stoelenEnTapeind", question: "Q_CHAIRS_AND_TAPE_END", options: Lookup.stoelenEnTapeind.map((x, i) => ({ value: x, index: i })) },
];
export const puntstukken = [
    { key: "puntStukMateriaal", question: "Q_POINT_BLADE_MATERIAL", options: Lookup.materiaal.map((x, i) => ({ value: x, index: i, alt: x.includes("MN") ? "MN" : x.includes("HT") ? "HT" : undefined })) },
];
export const wisselstellers = [
    { key: "wisselsteller", question: "Q_SWITCH_ACTUATOR_DIRECTION", options: Lookup.wisselstellerDirections.map((x, i) => ({ value: x, index: i })) },
];
export const questions = {
    halveTongbewegingen,
    puntstukken,
    wisselstellers,
};
